// src/staff/pages/StaffRingiForm.tsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StaffLayout from "../components/StaffLayout";

export {}; // module safety

type FormState = {
  sales_staff_name: string;
  cuppy_contract: "" | "有" | "無";
  application_background: string;
  current_status: string;

  latest_fiscal_month: string;
  annual_revenue_million: string;
  annual_profit_thousand: string;

  reason: string;
  planned_credit_company: string;
  customer_fee_percent: string;
  upper_amount_man: string;
  upper_payments: string;
  merchant_fee_percent: string;
  sales_opinion: string;

  ops_staff_name: string;
  ops_opinion: string;
  application_date: string;

};

const API_BASE = "/api";
const MAX_500 = 500;

export default function StaffRingiForm() {
  const navigate = useNavigate();
  const { merchantId } = useParams();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [form, setForm] = useState<FormState>({
    sales_staff_name: "",
    cuppy_contract: "",
    application_background: "",
    current_status: "",

    latest_fiscal_month: "",
    annual_revenue_million: "",
    annual_profit_thousand: "",

    reason: "",
    planned_credit_company: "",
    customer_fee_percent: "",
    upper_amount_man: "",
    upper_payments: "",
    merchant_fee_percent: "",
    sales_opinion: "",

    ops_staff_name: "",
    ops_opinion: "",
    application_date: "",

  });

  const setField = (k: keyof FormState, v: string) => setForm((p) => ({ ...p, [k]: v }));

  // ✅ Load saved draft + auto-fill sales_staff_name from assigned JMC staff (NOT logged-in name)
  useEffect(() => {
    const run = async () => {
      setError("");
      setMessage("");
      setLoading(true);

      if (!merchantId) {
        setError("merchantId が見つかりません。");
        setLoading(false);
        return;
      }

      try {
        // ① load ringi draft
        const res = await fetch(`${API_BASE}/staff/ringi/${merchantId}`);
        const json = await res.json().catch(() => ({}));

        if (!res.ok) {
          setError(json?.detail || "稟議書データの取得に失敗しました。");
          setLoading(false);
          return;
        }

        const d = json?.data || {};
const assignees: string[] = json?.assignees || [];

const assignedSalesName = (assignees[0] || "").trim();

setForm({
  sales_staff_name: (d.sales_staff_name || "").trim() || assignedSalesName,
  cuppy_contract: d.cuppy_contract || "",
  application_background: d.application_background || "",
  current_status: d.current_status || "",

  latest_fiscal_month: d.latest_fiscal_month || "",
  annual_revenue_million: d.annual_revenue_million || "",
  annual_profit_thousand: d.annual_profit_thousand || "",

  reason: d.reason || "",
  planned_credit_company: d.planned_credit_company || "",
  customer_fee_percent: d.customer_fee_percent || "",
  upper_amount_man: d.upper_amount_man || "",
  upper_payments: d.upper_payments || "",
  merchant_fee_percent: d.merchant_fee_percent || "",
  sales_opinion: d.sales_opinion || "",

  ops_staff_name: d.ops_staff_name || "",
  ops_opinion: d.ops_opinion || "",
  application_date: d.application_date || "",

});


        setLoading(false);
      } catch {
        setError("バックエンドが起動しているか確認してください。");
        setLoading(false);
      }
    };

    run();
  }, [merchantId]);

  const requiredErrors = useMemo(() => {
    const errs: string[] = [];

    if (!form.sales_staff_name.trim()) errs.push("営業担当は必須です。");
    if (!form.cuppy_contract) errs.push("Cuppy（有/無）は必須です。");
    if (!form.application_background.trim()) errs.push("申請背景は必須です。");
    if (!form.current_status.trim()) errs.push("現状は必須です。");
    if (!form.planned_credit_company.trim()) errs.push("導入予定信販会社は必須です。");
    if (!form.customer_fee_percent.trim()) errs.push("顧客手数料は必須です。");
    if (!form.upper_amount_man.trim()) errs.push("上限金額は必須です。");
    if (!form.upper_payments.trim()) errs.push("上限支払回数は必須です。");
    if (!form.merchant_fee_percent.trim()) errs.push("加盟店手数料は必須です。");
    if (!form.sales_opinion.trim()) errs.push("営業担当所見は必須です。");

    if (!form.ops_staff_name.trim()) errs.push("業務担当は必須です。");
    if (!form.ops_opinion.trim()) errs.push("業務担当所見は必須です。");

    const check500 = (label: string, v: string) => {
      if (v.length > MAX_500) errs.push(`${label} は500文字以内です。`);
    };
    check500("申請背景", form.application_background);
    check500("現状", form.current_status);
    check500("理由", form.reason);
    check500("営業担当所見", form.sales_opinion);
    check500("業務担当所見", form.ops_opinion);

    return errs;
  }, [form]);

  const canComplete = requiredErrors.length === 0;

  const onSaveDraft = async () => {
    setError("");
    setMessage("");

    console.log("RINGI SAVE DRAFT merchantId:", merchantId);
    console.log("RINGI SAVE DRAFT payload:", form);


    if (!merchantId) {
      setError("merchantId が見つかりません。");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/staff/ringi/${merchantId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(json?.detail || "下書き保存に失敗しました。");
        return;
      }

      setMessage("保存しました（下書き）");

// ✅ re-fetch to confirm DB saved correctly and refresh UI
const resReload = await fetch(`${API_BASE}/staff/ringi/${merchantId}`);
const jsonReload = await resReload.json().catch(() => ({}));
if (resReload.ok) {
  const d2 = jsonReload?.data || {};
  const assignees2: string[] = jsonReload?.assignees || [];
  const assignedSalesName2 = (assignees2[0] || "").trim();

  setForm({
    sales_staff_name: (d2.sales_staff_name || "").trim() || assignedSalesName2,
    cuppy_contract: d2.cuppy_contract || "",
    application_background: d2.application_background || "",
    current_status: d2.current_status || "",

    latest_fiscal_month: d2.latest_fiscal_month || "",
    annual_revenue_million: d2.annual_revenue_million || "",
    annual_profit_thousand: d2.annual_profit_thousand || "",

    reason: d2.reason || "",
    planned_credit_company: d2.planned_credit_company || "",
    customer_fee_percent: d2.customer_fee_percent || "",
    upper_amount_man: d2.upper_amount_man || "",
    upper_payments: d2.upper_payments || "",
    merchant_fee_percent: d2.merchant_fee_percent || "",
    sales_opinion: d2.sales_opinion || "",

    ops_staff_name: d2.ops_staff_name || "",
    ops_opinion: d2.ops_opinion || "",
    application_date: d2.application_date || "",

  });
}
    } catch {
      setError("バックエンドが起動しているか確認してください。");
    } finally {
      setSaving(false);
    }
  };

  const onComplete = async () => {
    setError("");
    setMessage("");

    if (!merchantId) {
      setError("merchantId が見つかりません。");
      return;
    }
    if (!canComplete) return;

    setSaving(true);

    try {
      // ① Complete ringi
      const res1 = await fetch(`${API_BASE}/staff/ringi/${merchantId}/complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const json1 = await res1.json().catch(() => ({}));
      if (!res1.ok) {
        setError(json1?.detail || "稟議書完了に失敗しました。");
        return;
      }

      // ② Auto approve (same as clicking red button)
      const res2 = await fetch(`${API_BASE}/staff/approve/${merchantId}`, { method: "POST" });
      const json2 = await res2.json().catch(() => ({}));
      if (!res2.ok) {
        setError(json2?.detail || "承認に失敗しました。");
        return;
      }

      setMessage("稟議書完了 → 自動承認（承認済）しました。");
      navigate("/staff/progress");
    } catch {
      setError("バックエンドが起動しているか確認してください。");
    } finally {
      setSaving(false);
    }
  };

  return (
    <StaffLayout title="稟議書作成" active="progress">
      <button onClick={() => navigate(`/staff/progress/${merchantId}`)} style={styles.backBtn}>
        戻る（進捗詳細）
      </button>

      {loading && <div style={{ color: "#475569", fontWeight: 800 }}>読み込み中...</div>}

      {error && (
        <div
          style={{
            marginBottom: 12,
            background: "#fff1f2",
            border: "1px solid #fecdd3",
            color: "#b91c1c",
            padding: "10px 12px",
            borderRadius: 12,
            fontWeight: 900,
          }}
        >
          {error}
        </div>
      )}

      {!loading && (
        <div style={styles.outer}>
          <div style={styles.headerRow}>
            <div style={styles.pageTitle}>【JMC画面】稟議書作成</div>
            <div style={styles.merchantId}>加盟店ID：{merchantId}</div>
          </div>

          {/* 営業 */}
          <SectionTitle text="稟議書（営業）" />
          <Table>


            <Row
  label="申請日"
  required
  input={
    <input
      type="date"
      value={form.application_date}
      onChange={(e) => setField("application_date", e.target.value)}
      style={styles.input}
    />
  }
/>

            <Row
              label="営業担当（自動反映）"
              required
              input={
                <Input
                  value={form.sales_staff_name}
                  onChange={(v) => setField("sales_staff_name", v)}
                  placeholder="例：山田 太郎"
                />
              }
            />


            <Row
              label="Cuppy（自社クレジット）加盟店契約申請"
              required
              input={
                <Select
                  value={form.cuppy_contract}
                  onChange={(v) => setField("cuppy_contract", v)}
                  options={["有", "無"]}
                />
              }
            />

            <Row
              label="申請背景（500字まで）"
              required
              input={
                <Textarea
                  value={form.application_background}
                  onChange={(v) => setField("application_background", v)}
                />
              }
            />

            <Row
              label="現状（500字まで）"
              required
              input={<Textarea value={form.current_status} onChange={(v) => setField("current_status", v)} />}
            />

            <Row
              label="決算（任意）直近年度"
              input={
                <Input
                  value={form.latest_fiscal_month}
                  onChange={(v) => setField("latest_fiscal_month", v)}
                  placeholder="例：2025年12月"
                />
              }
            />

            <Row
              label="決算（任意）年商（百万円）"
              input={
                <Input
                  value={form.annual_revenue_million}
                  onChange={(v) => setField("annual_revenue_million", v)}
                  placeholder="数字のみ"
                />
              }
            />

            <Row
              label="決算（任意）当期利益（千円）"
              input={
                <Input
                  value={form.annual_profit_thousand}
                  onChange={(v) => setField("annual_profit_thousand", v)}
                  placeholder="数字のみ"
                />
              }
            />

            <Row
              label="理由（500字まで）"
              input={<Textarea value={form.reason} onChange={(v) => setField("reason", v)} />}
            />

            <Row
              label="導入予定信販会社"
              required
              input={
                <Input
                  value={form.planned_credit_company}
                  onChange={(v) => setField("planned_credit_company", v)}
                  placeholder="例：〇〇信販"
                />
              }
            />

            <Row
              label="顧客手数料（%）"
              required
              input={
                <Input
                  value={form.customer_fee_percent}
                  onChange={(v) => setField("customer_fee_percent", v)}
                  placeholder="例：3.5"
                />
              }
            />

            <Row
              label="上限金額（万円）"
              required
              input={
                <Input
                  value={form.upper_amount_man}
                  onChange={(v) => setField("upper_amount_man", v)}
                  placeholder="例：200"
                />
              }
            />

            <Row
              label="上限支払回数（回）"
              required
              input={
                <Input
                  value={form.upper_payments}
                  onChange={(v) => setField("upper_payments", v)}
                  placeholder="例：36"
                />
              }
            />

            <Row
              label="加盟店手数料（%）"
              required
              input={
                <Input
                  value={form.merchant_fee_percent}
                  onChange={(v) => setField("merchant_fee_percent", v)}
                  placeholder="例：2.8"
                />
              }
            />

            <Row
              label="営業担当所見（500字まで）"
              required
              input={<Textarea value={form.sales_opinion} onChange={(v) => setField("sales_opinion", v)} />}
            />
          </Table>

          {/* 業務 */}
          <SectionTitle text="稟議書（業務）" />
          <Table>
            <Row
              label="業務担当（自動反映）"
              required
              input={
                <Input
                  value={form.ops_staff_name}
                  onChange={(v) => setField("ops_staff_name", v)}
                  placeholder="例：佐藤 花子"
                />
              }
            />

            <Row
              label="業務担当所見（500字まで）"
              required
              input={<Textarea value={form.ops_opinion} onChange={(v) => setField("ops_opinion", v)} />}
            />
          </Table>

          {requiredErrors.length > 0 && (
            <div style={styles.warnBox}>
              <div style={styles.warnTitle}>未入力の必須項目があります：</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {requiredErrors.slice(0, 7).map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
              </ul>
              {requiredErrors.length > 7 && (
                <div style={{ marginTop: 6 }}>…他 {requiredErrors.length - 7} 件</div>
              )}
            </div>
          )}

          <div style={styles.btnRow}>
            <button onClick={onSaveDraft} disabled={saving} style={styles.draftBtn}>
              {saving ? "保存中..." : "保存（下書き）"}
            </button>

            <button disabled={!canComplete || saving} onClick={onComplete} style={styles.completeBtn(canComplete)}>
              {saving ? "処理中..." : "稟議書完了"}
            </button>
          </div>

          {message && <div style={styles.msg}>{message}</div>}
        </div>
      )}
    </StaffLayout>
  );
}

function SectionTitle({ text }: { text: string }) {
  return <div style={styles.sectionTitle}>{text}</div>;
}

function Table({ children }: { children: React.ReactNode }) {
  return <div style={styles.tableWrap}>{children}</div>;
}

function Row({ label, required, input }: { label: string; required?: boolean; input: React.ReactNode }) {
  return (
    <div style={styles.row}>
      <div style={styles.cellLabel}>
        <div style={styles.labelRow}>
          <span style={styles.labelText}>{label}</span>
          {required && <span style={styles.requiredParen}>（必須）</span>}
        </div>
      </div>
      <div style={styles.cellInput}>{input}</div>
    </div>
  );
}

function Input({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder?: string }) {
  return (
    <input
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      style={styles.input}
      onFocus={(e) => (e.currentTarget.style.border = "1px solid #2563eb")}
      onBlur={(e) => (e.currentTarget.style.border = "1px solid #cbd5e1")}
    />
  );
}

function Textarea({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={5}
      style={styles.textarea}
      onFocus={(e) => (e.currentTarget.style.border = "1px solid #2563eb")}
      onBlur={(e) => (e.currentTarget.style.border = "1px solid #cbd5e1")}
    />
  );
}

function Select({ value, onChange, options }: { value: string; onChange: (v: string) => void; options: string[] }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={styles.select}
      onFocus={(e) => (e.currentTarget.style.border = "1px solid #2563eb")}
      onBlur={(e) => (e.currentTarget.style.border = "1px solid #cbd5e1")}
    >
      <option value="">選択してください</option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  );
}

const styles: any = {
  backBtn: {
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid #cbd5e1",
    background: "#fff",
    color: "#0f172a",
    fontWeight: 700,
    cursor: "pointer",
    marginBottom: 12,
  },
  outer: {
    border: "1px solid #e2e8f0",
    background: "#fff",
    borderRadius: 16,
    padding: 16,
    maxWidth: 980,
    width: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: 12,
  },
  pageTitle: { fontWeight: 700, fontSize: 18, color: "#0f172a" },
  merchantId: {
    fontWeight: 700,
    color: "#334155",
    background: "#f1f5f9",
    border: "1px solid #e2e8f0",
    padding: "6px 10px",
    borderRadius: 12,
  },
  sectionTitle: {
    marginTop: 12,
    marginBottom: 10,
    padding: "10px 12px",
    borderRadius: 12,
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    fontWeight: 700,
    fontSize: 16,
    color: "#0f172a",
  },
  tableWrap: {
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    overflow: "hidden",
    marginBottom: 14,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "360px 1fr",
    borderTop: "1px solid #e2e8f0",
    minHeight: 72,
  },
  cellLabel: {
    padding: 12,
    background: "#f8fafc",
    display: "flex",
    alignItems: "center",
    borderRight: "1px solid #e2e8f0",
    minWidth: 0,
  },
  labelRow: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 },
  labelText: {
    fontSize: 13,
    fontWeight: 900,
    color: "#0f172a",
    lineHeight: 1.2,
    wordBreak: "break-word",
  },
  requiredParen: {
    color: "#b91c1c",
    fontSize: 13,
    fontWeight: 900,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  cellInput: { padding: 12, background: "#fff", minWidth: 0 },
  input: {
    width: "100%",
    height: 44,
    padding: "0 12px",
    borderRadius: 10,
    border: "1px solid #cbd5e1",
    background: "#fff",
    color: "#0f172a",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    height: 44,
    padding: "0 12px",
    borderRadius: 10,
    border: "1px solid #cbd5e1",
    background: "#fff",
    color: "#0f172a",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #cbd5e1",
    background: "#fff",
    color: "#0f172a",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    resize: "vertical",
  },
  warnBox: {
    marginTop: 10,
    background: "#fff7ed",
    border: "1px solid #fed7aa",
    padding: 12,
    borderRadius: 12,
    color: "#9a3412",
    fontWeight: 800,
  },
  warnTitle: { fontWeight: 900, marginBottom: 6 },
  btnRow: { display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" },
  draftBtn: {
    padding: "12px 14px",
    borderRadius: 12,
    border: "1px solid #cbd5e1",
    background: "#fff",
    fontWeight: 900,
    cursor: "pointer",
  },
  completeBtn: (enabled: boolean) => ({
    flex: 1,
    minWidth: 220,
    padding: "12px 14px",
    borderRadius: 12,
    border: "1px solid #1d4ed8",
    background: enabled ? "#2563eb" : "#cbd5e1",
    color: enabled ? "#fff" : "#475569",
    fontWeight: 900,
    cursor: enabled ? "pointer" : "not-allowed",
  }),
  msg: { marginTop: 12, fontWeight: 800, color: "#0f172a" },
};
